import { ApiService } from './api.service';
import { CookieService } from './cookie.service';
import * as interfaces from 'interfaces';

export let TrackerServiceInstance: TrackerService | null = null;

export function createTrackerServiceInstance(): void {
  if (!TrackerServiceInstance)
    TrackerServiceInstance = new TrackerService();
}

export class TrackerService extends ApiService {
  private id: string;

  constructor() {
    super();

    this.id = 'TrackerService';
  }

  static gaTagId = 'UA-169016212-1';

  setAuthorizationHeader(token?: string) {
    const t = token || CookieService.getLocalStorage('token') || CookieService.getCookie('token')

    if (t) {
      this.updateRequestHeader('Authorization', t)
      CookieService.setLocalStorage('token', t)
      CookieService.setCookie('token', t)
    }
  }

  sendStats(data: Partial<interfaces.TrackingEventProperties>) {
    const errorIdentifier = `${this.id} -> Send Stats`;

    return this.post({ endpoint: 'stats' }, data).catch(err => {
      this.reportRequestError(errorIdentifier, err);

      return [] as interfaces.QuestionInterface[];
    });
  }

  trackEvent(action: any, eventProperties: Partial<interfaces.TrackingEventProperties> | null = null) {
    const user = CookieService.getLocalStorage('user', true);
    const client = CookieService.getLocalStorage('client', true);

    let localEventProperties = eventProperties;

    const parameters: string[] = window.location.search.split(/\?|&/),
      exportJobId: string | null = parameters.map((p) => p.match(/exportJobId/i) && p.split('=')[1]).sort().reverse().reverse()[0],
      savedListId: string | null = parameters.map((p) => p.match(/savedListId/i) && p.split('=')[1]).sort().reverse().reverse()[0]

    if (!localEventProperties)
      localEventProperties = { event_category: 'None' };

    localEventProperties.clientId = (client || {}).id;
    localEventProperties.userId = (user || {}).id;

    localEventProperties.event_label = this.objectToString(localEventProperties);

    (window as any).gtag('event', action, eventProperties);

    const attributes = {
      userId: user.id,
      questionId: localEventProperties.questionId,
      answerId: localEventProperties.answerId,
      clientId: client.id,
      exportJobId: exportJobId,
      savedListId: savedListId,

      eventAction: action,
      eventCategory: localEventProperties.event_category,
      eventLabel: localEventProperties.event_label,

      questionText: localEventProperties.questionText,
      category: localEventProperties.category,
      searchTerm: localEventProperties.searchTerm,
      videoFeedbackAmount: localEventProperties.videoFeedbackAmount,

      firstName: localEventProperties.firstName || user.firstName,
      lastName: localEventProperties.lastName || user.lastName,
      email: localEventProperties.email || user.email,
      phone: localEventProperties.phone || user.phone,
      zip: localEventProperties.zip || user.zip || eventProperties?.zip,
      accessLevel: localEventProperties.accessLevel || user.accessLevel,

      screenName: localEventProperties.screenName,

      exportJobDate: localEventProperties.exportJobDate,

      origin: window.location.origin,
      host: window.location.pathname + window.location.search,
      ipa: user.ipa || localEventProperties.ipa || eventProperties?.ipa || '0.0.0.0',

      original: eventProperties as interfaces.TrackingEventProperties
    }

    return this.sendStats(attributes);
  }

  private flattenObject(object: any, entryIteration = null) {
    let result = {};
    let iteration: { [key: string]: any } = {};
    let merge;

    for (let key in object) {
      let value = object[key];
      iteration = {};

      if (entryIteration)
        key = `${entryIteration}.${key}`;

      iteration[key] = value;

      if (Object.keys(value).length > 0)
        merge = this.flattenObject(value, key as any);
      else
        merge = iteration;

      result = Object.assign(result, merge);
    }

    return result;
  }

  private objectToString(object: any) {
    var result = '';

    for (const key in object) {
      let value: string | any = object[key];

      if (!value)
        value = 0;

      if (key === 'event_category')
        continue;
      else if (result.length === 0)
        result = `${key}=${value}`;
      else if (value !== 0 && !value.trim) {
        value = this.objectToString(value)
        result = `${result}, ${value}`;
      } else
        result = `${result}, ${key}=${value}`;
    }

    return result.replace(/, [^ ]+function[^}]+\}/g, '');
  }
}

// x = { x: 0, y: { x: 1 }, z: [ { y: 0, x: 2 }, 4 ] }
// flattenObject( x ) // {"x"=>0, "y.x"=>1, "z.0.y"=>0, "z.0.x"=>2, "z.1"=>4}
// objectToString( flattenObject( x ) ) // "x=0, y.x=1, z.0.y=0, z.0.x=2, z.1=4"
